import { render, staticRenderFns } from "./App.vue?vue&type=template&id=7410d97e&scoped=true"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=7410d97e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7410d97e",
  null
  
)

export default component.exports